import ColorConvert from 'color-convert'
import { computed, observable, subscribe } from 'knockout-decorators'

import { CartPrecheckStatus, EventSaleStatus } from '@tixa/schema'

import { EventState } from './store/event'
import { pageState } from './store/page'
import { Tracker, Locale, Translations } from './utils'

import { PaymentPrechecker } from './components/payment-checker/payment-prechecker'

import './components/cart/cart'
import './components/event-box/offer-list'

import '@fontsource/nunito/variable.css'

import './styles/bootstrap.scss'
import './embed.less'
import './components/cart/cart.less'
import './components/cart/cart.embed.less'
import './components/event-box/offer-list.embed.less'
import './components/event-box/ticket-type.embed.less'
import './styles/buttons.embed.less'

import './utils/embed-responder'

export class EmbedPage {
  private eventState: EventState = EventState.get()

  @computed get canBuy(): boolean {
    return this.eventState.canBuy
  }

  @computed get buyCtaText(): string {
    if (this.eventState.offers.some((offer) => offer.price > 0)) {
      return Translations.buy
    }
    return Translations.reserveticket
  }

  @computed get hasTouristTax(): boolean {
    return this.eventState.events.some((event) => event.hasTouristTax === true)
  }

  @observable public isLoaded = false
  public eventId = ''

  private offerConfig = {}

  private readonly themeAttributes = {
    attention: '--attention',
    background: '--background',
    border: '--border',
    light: '--text-light',
    primary: '--primary',
    text: '--text',
  }

  private readonly defaultTheme = {
    attention: '#e5364d',
    background: 'white',
    border: '#e0e0e0',
    light: '#4c4c4c',
    primary: '#0cb586',
    text: '#3e3e3e',
  }

  private eM: Map<CartPrecheckStatus, string> = new Map<
    CartPrecheckStatus,
    string
  >([
    [CartPrecheckStatus.codeExpired, Translations.codeused],
    [CartPrecheckStatus.couponExpired, Translations.codeused],
    [CartPrecheckStatus.failure, Translations.waiterror],
    [CartPrecheckStatus.error, Translations.waiterror],
    [CartPrecheckStatus.invalid, Translations.waiterror],
  ])

  constructor(params: any) {
    if (params.embedParent) {
      ;(window as any).embedOrigin = params.embedParent
    }
    subscribe<string>(
      () => this.eventState.globalError,
      (newError) => {
        if (newError?.length > 0) {
          this.openError(newError)
        }
      }
    )
    if (params.lang) {
      Locale.setLocale(params.lang)
    } else {
      Locale.setLocale('hu')
    }
    Object.entries(this.themeAttributes).forEach((attribute) => {
      const color = params[attribute[0]]
        ? params[attribute[0]]
        : this.defaultTheme[attribute[0]]
      const rgbColor =
        color.indexOf('#') === 0
          ? ColorConvert.hex.rgb(color)
          : ColorConvert.keyword.rgb(color)
      document.body.style.setProperty(attribute[1], color)
      document.body.style.setProperty(
        `${attribute[1]}-rgb`,
        `${rgbColor[0]}, ${rgbColor[1]}, ${rgbColor[2]}`
      )
    })
    this.loadData(params).then(() => {
      PaymentPrechecker.check()
    })
  }

  private async loadData(params) {
    const offerList = await pageState.api.embed.loadOffers(
      params.event,
      params.lang
    )

    if ('config' in offerList && offerList.config) {
      pageState.config = offerList.config
    }

    const id = offerList['@id'].split('-')[1].toString()
    if (offerList.token) {
      const metaEl = document.createElement('meta')
      metaEl.setAttribute('name', 'tixa-csrf-token')
      metaEl.setAttribute('content', offerList.token)
      document.head.appendChild(metaEl)
    }
    if (offerList.analyics) {
      Tracker.init(offerList.analyics)
    }
    this.eventState.events.push({
      eventID: id,
      hasContent: false,
      hasCoupons: 'coupons' in params || offerList.hasCoupons,
      hasSeatmap: false,
      name: offerList.name,
      saleStatus: EventSaleStatus.onsale,
    })
    this.eventState.offers.push(
      ...offerList.itemListElement.map((offer) => {
        offer.eventID = id
        offer.eligibleQuantity.value = 0
        return offer
      })
    )
    this.eventId = id
    this.isLoaded = true
  }

  public openError(message: string) {
    console.error(message)
  }

  private async buyClicked() {
    await this.eventState.submitter.buy(this.hasTouristTax)
  }
}
